import { CreditCard } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { BILLING_PERMISSIONS } from '@/lib/permissions'

import { billingSettingsRoute } from './routes'

export const billingModule = defineModule({
  routes: [billingSettingsRoute],
  navigation: {
    admin: [
      {
        to: '/$entityId/settings/billing',
        label: 'Billing',
        icon: CreditCard,
        permission: BILLING_PERMISSIONS.accountManage,
        section: 'settings',
        order: 40,
      },
    ],
  },
})
